import http from '@frontend/api/http';
import { HYPATIA_URL } from '@frontend/envConfig';
import { WebhookTrigger } from '@frontend/types/workflow-agent';

// Type for partial updates to webhook triggers
export type WebhookTriggerUpdate = Partial<Omit<WebhookTrigger, 'id' | 'type'>>;

export const updateWebhookTrigger = async (
  url: string,
  updates: WebhookTriggerUpdate
): Promise<WebhookTrigger> => {
  console.warn('Updating webhook trigger with:', updates);
  const response = await http.patch<WebhookTrigger>(url, updates);
  return response.data;
};

export const createWebhookTrigger = async (
  agentId: string,
  instanceId: string,
  trigger: Record<string, unknown>
): Promise<WebhookTrigger> => {
  const url = `${HYPATIA_URL}/api/v1/${instanceId}/agents/workflows/${agentId}/triggers/webhook`;
  const response = await http.post<WebhookTrigger>(url, trigger);
  return response.data;
};

export const getWebhookTrigger = async (url: string): Promise<WebhookTrigger> => {
  const response = await http.get<WebhookTrigger>(url);
  return response.data;
};

export const deleteWebhookTrigger = async (url: string): Promise<void> => {
  await http.delete(url);
};
